// src/apis/endpoints.js

const BASE_URL = process.env.REACT_APP_BASE_URL;
const V1_URL = `${BASE_URL}v1`;
const V2_URL = `${BASE_URL}v2`;

const API_ENDPOINTS = {
    LOGIN: `${V1_URL}/auth/login/`,
    LOGOUT: `${V1_URL}/auth/logout/`,
    CREATE_DEVICE_ID: `${V1_URL}/auth/device/`,
    EXCHANGE_TOKEN: `${V1_URL}/auth/access/`,

    // SEND_VERIFICATION_CODE: `${V1_URL}/auth/login/`,
    // VERIFY_CODE: `${V1_URL}/auth/verify/`,
    // RESEND_CODE: `${V1_URL}/auth/resend/`,
    // GOOGLE_TOKEN: `${V1_URL}/auth/google/`,

    CALENDAR: `${V1_URL}/utilities/calendar/`,
    CATEGORY: `${V1_URL}/utilities/calendar/categories/`,
    // CALENDAR_SEARCH: `${V1_URL}/dashboard/features/calendar/search/`,

    FOOTBALL: `${V1_URL}/reports/games/football/`,
    MOVIES: `${V1_URL}/reports/movies/`,
    BRANDS: `${V1_URL}/reports/brands/`,

    PRODUCT: `${V1_URL}/dashboard/feeder/product-roadmap/`,
    GALLERI5_JM: `${V1_URL}/dashboard/feeder/galleri5-jm/`,
    BBS_Marketing: `${V1_URL}/dashboard/feeder/bbs/`,
    BBS_APP_PROGRAMS: `${V1_URL}/dashboard/feeder/bbs/`,
    BBS_AFFILIATE: `${V1_URL}/dashboard/feeder/bbs-affiliate/`,

    ENGAGEMENT_INSIGHT_HISTORY: `${V1_URL}/analytics/social/engagement/history/`,
    ENGAGEMENT_INSIGHT: `${V1_URL}/analytics/social/engagement/`,

    ADMIN_USER: `${V1_URL}/admin/users/`,
    REPORTS_EXECUTIVE: `${V1_URL}/reports/executive/`,

    USER: `${V1_URL}/user/`,

    CHAT_GPT: `${V2_URL}/chat/`,

    BBS_WEEK: `${V1_URL}/reports/executive/bbs/weeks/`,
    BBS_DATA: `${V1_URL}/reports/executive/bbs/`,

    ROADMAP: `${V1_URL}/reports/executive/roadmap/`,
    PRODUCT_LIST: `${V1_URL}/reports/executive/roadmap/products/`,

    ACADEMY_WEEKS: `${V1_URL}/reports/executive/academy/weeks/`,
    ACADEMY_DATA: `${V1_URL}/reports/executive/academy/`,

    G5_WEEKS: `${V1_URL}/reports/executive/galleri5/weeks/`,
    G5_DATA: `${V1_URL}/reports/executive/galleri5/`,

    TTT_WEEKS: `${V1_URL}/reports/executive/ttt/weeks/`,
    TTT_DATA: `${V1_URL}/reports/executive/ttt/`,

    U25_WEEKS: `${V1_URL}/reports/executive/under25/weeks/`,
    U25_DATA: `${V1_URL}/reports/executive/under25/`,

    CREATORS_TECH_WEEKS: `${V1_URL}/reports/executive/creatorstech/weeks/`,
    CREATORS_TECH_DATA: `${V1_URL}/reports/executive/creatorstech/`,

    MOVIES_METRICS: `${V1_URL}/reports/movies/metrics/`,
    NEWSLETTER: `${V1_URL}/newsletter/`,

    OVERLAP_DATA: `${V1_URL}/analytics/social/overlap/`,

    AI_MODEL_VOICE: `${V1_URL}/ai-models/voice/`,
    STORAGE: `${V1_URL}/storage/`,
    AI_MODEL_AVATAR: `${V1_URL}/ai-models/avatar/`,
    INSTAGRAM_CHANNEL_METRICS: `${V1_URL}/ig_data/data/`,
    INSTAGRAM_CHANNEL_ACCOUNTS: `${V1_URL}/ig_data/accounts/`,

    CREATORS_ACCOUNTS: `${V1_URL}/reports/creators/`,
    BRANDCONNECT_ACCOUNTS: `${V1_URL}/reports/brandconnect/`,
    BRANDCONNECT_ACCOUNT_CONTENT: `${V1_URL}/reports/brandconnect/`,
};

export default API_ENDPOINTS;
